<div class="flex min-h-screen bg-amber-400">
  <!-- Right side - Change Password Form -->
  <div
    class="w-full flex items-center justify-center p-8 bg-amber-400 relative"
    style="
      background-image: url('assets/patrones/fondo_patron_subito.webp');
      background-size: 200px 200px;
      background-repeat: repeat;
      background-position: center;
    "
    >
    <div class="w-full max-w-2xl bg-white rounded-4xl shadow-lg p-8">
      <div class="text-center mb-10">
        <div class="flex justify-center mb-4">
          <a href="/">
            <figure>
              <img
                src="assets/logo/logo_full.png"
                alt="Logo"
                class="h-20 w-auto"
                />
              </figure>
            </a>
          </div>
          @if (tokenIsValid.status) {
            <p class="text-gray-600 mt-2">Actualiza tu contraseña</p>
          }
          @if (!tokenIsValid.status) {
            <p class="text-gray-600 mt-2">{{tokenIsValid.message}}</p>
          }
        </div>

        @if (tokenIsValid.status) {
          <h2 class="text-2xl font-bold text-gray-800 mb-6">Cambiar Contraseña</h2>
        }

        @if (tokenIsValid.status) {
          <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="space-y-6">
            <!-- New Password Field -->
            <div>
              <label
                for="newPassword"
                class="block text-sm font-medium text-gray-700 mb-1"
                >Nueva Contraseña</label
                >
                <div class="relative">
                  <input
                    type="{{ showNewPassword() ? 'text' : 'password' }}"
                    id="newPassword"
                    formControlName="newPassword"
                    class="w-full pl-4 pr-12 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
            [ngClass]="{
              'border-red-500':
                newPassword?.invalid && (newPassword?.dirty || newPassword?.touched)
            }"
                    placeholder="••••••••"
                    />
                  <button
                    type="button"
                    (click)="toggleShowNewPassword()"
                    class="absolute inset-y-0 right-0 flex items-center px-3 text-amber-500"
                    aria-label="Mostrar u ocultar nueva contraseña"
                  >
                    @if (!showNewPassword()) {
                      <i class="fas fa-eye"></i>
                    }
                    @if (showNewPassword()) {
                      <i class="fas fa-eye-slash"></i>
                    }
                  </button>
                </div>
                  @if (newPassword?.invalid && (newPassword?.dirty || newPassword?.touched)) {
                    <div
                      class="text-red-500 text-sm mt-1"
                      >
                      @if (newPassword?.errors?.['required']) {
                        <div>
                          La contraseña es requerida
                        </div>
                      }
                      @if (newPassword?.errors?.['minlength']) {
                        <div>
                          La contraseña debe tener al menos 8 caracteres
                        </div>
                      }
                      @if (newPassword?.errors?.['pattern']) {
                        <div>
                       La contraseña debe incluir al menos una minúscula, mayúscula, número y un carácter ($, @, %, &, otro)
                        </div>
                      }
                    </div>
                  }
                </div>
                <!-- Confirm Password Field -->
                <div>
                  <label
                    for="confirmPassword"
                    class="block text-sm font-medium text-gray-700 mb-1"
                    >Confirmar Contraseña</label
                    >
                    <div class="relative">
                      <input
                        type="{{ showConfirmPassword() ? 'text' : 'password' }}"
                        id="confirmPassword"
                        formControlName="confirmPassword"
                        class="w-full pl-4 pr-12 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
            [ngClass]="{
              'border-red-500':
                (confirmPassword?.invalid || passwordForm?.errors?.['passwordMismatch']) &&
                (confirmPassword?.dirty || confirmPassword?.touched)
            }"
                        placeholder="••••••••"
                        />
                      <button
                        type="button"
                        (click)="toggleShowConfirmPassword()"
                        class="absolute inset-y-0 right-0 flex items-center px-3 text-amber-500"
                        aria-label="Mostrar u ocultar confirmar contraseña"
                      >
                        @if (!showConfirmPassword()) {
                          <i class="fas fa-eye"></i>
                        }
                        @if (showConfirmPassword()) {
                          <i class="fas fa-eye-slash"></i>
                        }
                      </button>
                    </div>
                      @if ((confirmPassword?.invalid || passwordForm?.errors?.['passwordMismatch']) &&
                        (confirmPassword?.dirty || confirmPassword?.touched)) {
                        <div
                          class="text-red-500 text-sm mt-1"
                          >
                          @if (confirmPassword?.errors?.['required']) {
                            <div>
                              Confirmar la contraseña es requerido
                            </div>
                          }
                          @if (passwordForm?.errors?.['passwordMismatch']) {
                            <div>
                              Las contraseñas no coinciden
                            </div>
                          }
                        </div>
                      }
                    </div>
                    <!-- Submit Button -->
                    <button
                      type="submit"
                      [disabled]="passwordForm?.invalid || isLoading"
                      class="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-white bg-amber-500 hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                      >
                      @if (!isLoading) {
                        <span class="flex items-center">
                          Actualizar Contraseña
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 ml-2"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            >
                            <path
                              fill-rule="evenodd"
                              d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                              clip-rule="evenodd"
                              />
                            </svg>
                          </span>
                        }
                        @if (isLoading) {
                          <span class="flex items-center">
                            <svg
                              class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              >
                              <circle
                                class="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-width="4"
                              ></circle>
                              <path
                                class="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                            Procesando...
                          </span>
                        }
                      </button>
                    </form>
                  }

                  <!-- Footer -->
                  <div class="text-center text-xs text-gray-500 mt-10">
                    © 2025 Subito. Todos los derechos reservados.
                  </div>
                </div>
              </div>
            </div>
